import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thankyoudesktop',
  templateUrl: './thankyoudesktop.component.html',
  styleUrls: ['./thankyoudesktop.component.scss']
})
export class ThankyoudesktopComponent implements OnInit {

  public randomNr = Math.random()*9999999999;
  public urlmac = "https://download.xeotek.io/professional/mac.zip?api_key=xpGiDIONLVAr02Dpvq2348XVLIiWNAvz2u4ByY0BBLF2B1WvqksfH5&license=kadep-mtywn-tg4nt-e0nza1mc1ilmj1awnrl"+this.randomNr;
  public urlwin = "https://download.xeotek.io/professional/win.zip?api_key=xpGiDIONLVAr02Dpvq2348XVLIiWNAvz2u4ByY0BBLF2B1WvqksfH5&license=kadep-mtywn-tg4nt-e0nza1mc1ilmj1awnrl"+this.randomNr;
  public urllinux = "https://download.xeotek.io/professional/linux.tar.gz?api_key=xpGiDIONLVAr02Dpvq2348XVLIiWNAvz2u4ByY0BBLF2B1WvqksfH5&license=kadep-mtywn-tg4nt-e0nza1mc1ilmj1awnrl"+this.randomNr;
  constructor() { }

  ngOnInit(): void {
  }

}
